import bodybuilder from 'bodybuilder'
import { format } from 'date-fns'

import * as Elasticsearch from '../../../services/elasticsearch'

import { OpenClickPoint, ViewState, SuspectOptionTypes } from './types'

const EVENT_AGGREGATION: string = 'event'
const DATE_AGGREGATION: string = 'date'

export const parseStats = (payload: Elasticsearch.AggregationResponsePayload): OpenClickPoint[] => {
  const dateAggregationsBuckets = payload.aggregations[DATE_AGGREGATION].buckets
    .filter((aggregation: Elasticsearch.ResponseAggregate) => {
      return Elasticsearch.getAggregation(aggregation.child, 'delivered')
    })
  return dateAggregationsBuckets.map((aggregation: Elasticsearch.ResponseAggregate) => {
    const clicks = Elasticsearch.getAggregation(aggregation.child, 'click')
    const opens = Elasticsearch.getAggregation(aggregation.child, 'open')
    const delivered = Elasticsearch.getAggregation(aggregation.child, 'delivered')
    const bounces = Elasticsearch.getAggregation(aggregation.child, 'hard_bounce')
    const dropped = Elasticsearch.getAggregation(aggregation.child, 'dropped')
    const d = new Date(new Date(aggregation.key))
    const dateWithoutOffset = d.setMinutes(d.getMinutes() + d.getTimezoneOffset())
    const partial: any = {
      timestamp: format(new Date(dateWithoutOffset), 'iii, MMM do'),
      totalClick: clicks ? clicks.doc_count || 0 : 0,
      totalDelivered: delivered ? delivered.doc_count || 0 : 0,
      totalOpen: opens ? opens.doc_count || 0 : 0,
      uniqueClick: clicks && clicks.unique ? clicks.unique.value : 0,
      uniqueDelivered: delivered && delivered.unique ? delivered.unique.value : 0,
      uniqueOpen: opens && opens.unique ? opens.unique.value : 0,
      uniqueBounces: (bounces && bounces.unique ? bounces.unique.value : 0 ) +
                     (dropped && dropped.unique ? dropped.unique.value : 0),
    }
    return {
      ...partial,
      totalClickRate: (
        (partial.totalDelivered > 0 ?
          partial.totalClick / partial.totalDelivered : 0) * 100.0),
      totalOpenRate: (
        (partial.totalDelivered > 0 ?
          partial.totalOpen / partial.totalDelivered : 0) * 100.0),
      uniqueClickRate: (
        (partial.uniqueDelivered > 0 ?
          partial.uniqueClick / partial.uniqueDelivered : 0) * 100.0),
      uniqueOpenRate: (
        (partial.uniqueDelivered > 0 ?
          partial.uniqueOpen / partial.uniqueDelivered : 0) * 100.0),
    }
  })
}

export const searchPayload = (viewState: ViewState): any => {
  const dateFilter: any = Elasticsearch.toFilter(viewState.selectedDateRange.value)
  let search = bodybuilder().size(0)
    .filter(Elasticsearch.FilterType.range, 'message_send_date', dateFilter)

  if ( viewState.selectedSuspect.value === SuspectOptionTypes.Real ) {
    search = search.filter(Elasticsearch.FilterType.term, 'suspect_click', 0)
  }

  return Elasticsearch.addAggregation(search, {
    type: Elasticsearch.AggregationType.date_histogram,
    field: 'message_send_date',
    extra: { interval: viewState.selectedInterval.value },
    name: DATE_AGGREGATION,
    child: {
      type: Elasticsearch.AggregationType.terms,
      field: 'event_name.keyword',
      name: EVENT_AGGREGATION,
      unique_on: 'community_person_id',
    },
  }).build()
}

